import React from 'react';
import { Box, Modal } from '@razorpay/blade/components';
import { WizardInfoProvider } from 'components/WizardViews/providers';
import { WizardHeader } from 'components/WizardViews/components';
import { FormProvider } from 'forms';
import { Wizard, WizardStep } from 'forms/Wizard';
import {
  INITIAL_ADMIN_LOAN_FORM_DATA,
  AdminCreateLoanFormData,
  AdminCreateLoanProps,
} from './types';
import { BasicDetails } from './BasicDetails';
import { AmountInterest } from './AmountInterest';
import { RepaymentDetails } from './RepaymentDetails';
import { ReviewRequest } from './ReviewRequest';

export const AdminCreateLoan = ({ isOpen, onClose }: AdminCreateLoanProps) => {
  return (
    <Modal isOpen={isOpen} onDismiss={onClose} size="full">
      <FormProvider<AdminCreateLoanFormData> initialState={INITIAL_ADMIN_LOAN_FORM_DATA}>
        <WizardInfoProvider
          initialStep={0}
          totalSteps={4}
          onWizardClose={onClose}
          onSuccess={onClose}>
          <Box display="flex" flexDirection="column" height="100%">
            <WizardHeader heading="Create" subHeading="" onCloseClick={onClose} />
            <Box flex={1} overflowY="auto" display="flex" flexDirection="column">
              <Wizard>
                <WizardStep step={0} component={BasicDetails} />
                <WizardStep step={1} component={AmountInterest} />
                <WizardStep step={2} component={RepaymentDetails} />
                <WizardStep step={3} component={ReviewRequest} />
              </Wizard>
            </Box>
          </Box>
        </WizardInfoProvider>
      </FormProvider>
    </Modal>
  );
};

export default AdminCreateLoan;
